module.exports = __webpack_public_path__ + "static/img/p4.e81622d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/p4.png
// module id = Knoj
// module chunks = 0